module.exports = __webpack_public_path__ + "static/img/xiadanbishu.b44134bb.png";